/* Componente interno al drawer per la creazione della Toc */

import React from 'react';
//import layerImage from './InfoLayer.svg'
import layerImage from './info.png'
import CloseIcon from '@material-ui/icons/Close';
import './ClickOnMap.css'
import { Trans } from 'react-i18next';


import { useTranslation } from 'react-i18next';
import DrawerLayerToc from './DrawerLayerToc';


export default function DrawerComponent(props,container) {
  
  useTranslation()
  return (
        <div className={"lateraltDiv"}>
          <div className={"title"}>
            <img src={layerImage} alt="Calcolo" className={"tocImage"}></img><Trans>Informazioni</Trans> <button className={"buttonClose"} onClick={props.callback}><CloseIcon/></button></div>
  
           {  <DrawerLayerToc data={props} /> }
        </div>

  );
}